import React from "react";
import PropTypes from "prop-types";

function SpeakerCard({ personName, personImg, personDesc, personLinkedIn, extraDetails }) {

    if( extraDetails ) {
      var descTags = extraDetails.map(
        (detail) => (
          <p className="text-gray-800 text-base px-6 mb-5">
            {detail}
          </p>
        )
      );
    }
    return (
        <div className="w-full md:w-1/3 p-6 flex flex-col flex-shrink">
        <div className="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow">
        <a href={personLinkedIn} className="flex flex-wrap no-underline hover:no-underline">
            { (personImg)? (<p className="w-full text-gray-600 text-xs md:text-sm px-6">
            <img className="h-50 w-50 speaker" src={personImg} />
            </p>):(<p></p>)} 

            <div className="w-full text-center">
              <div className="font-bold text-xl text-gray-800 px-6">
                {personName}
              </div>
              <p className="text-gray-800 text-base px-6 mb-5">
              {personDesc}
              </p>
              {descTags}
            </div>

          </a>
        </div>
        { (personLinkedIn)? (<div className="flex-none mt-auto bg-white rounded-b rounded-t-none overflow-hidden shadow p-6">
          <div className="flex items-center  justify-center">
            <a href={personLinkedIn} target="_blank"><button className="mx-auto lg:mx-0 hover:underline gradient text-white font-bold rounded-full  py-4 px-8 shadow-lg">LinkedIn</button></a>
          </div>
        </div>):(<p></p>)}
      </div>
    );
}

SpeakerCard.defaultProps = {
    personName: 'Dummy Man',
    personDesc: 'A super dummy man',
    personLinkedIn: '"https://linkedin.com/test"'
};

SpeakerCard.propTypes = {
    personName: PropTypes.string.isRequired,
    personDesc: PropTypes.string.isRequired,
    personLinkedIn: PropTypes.string.isRequired,
    personImg: PropTypes.string.isRequired
}

export default SpeakerCard;
